import { makeStyles } from '@material-ui/core/styles';

const ITEM_HEIGHT = 38;
// https://mui.com/customization/palette/
export const useStyles = makeStyles((theme) => ({
  introMenu: {
    maxHeight: ITEM_HEIGHT * 15,
    width: 350,
    backgroundColor: `${(theme as any).palette.background.dark1}`,
  },
  textField: {
    fontSize: '1rem',
    width: '150px',
  },
  label: {
    fontSize: '1rem',
  },
}));
